import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ActionButton from "../../../shared/button/ActionButton";
import { DomesticCountryForm } from "./DomesticCountryForm";
import MUIModal from '../../../shared/MUIModal';

export const UpdateDomesticCountryDialog = ({
  open,
  onClose,
  onSubmit,
  formState,
  localized,
}) => {
  const {
    countryCode,
    displayName,
    countryCodeTouched,
    displayNameTouched,
    handleCountryCodeChange,
    handleDisplayNameChange,
    handleCountryCodeBlur,
    handleDisplayNameBlur,
    isFormValid,
    dialogError,
    validateCountryCode,
    validateDisplayName,
  } = formState;

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Force validation of all fields by checking if they're valid
    const countryCodeError = validateCountryCode(countryCode);
    const displayNameError = validateDisplayName(displayName);

    // If there are any validation errors, mark fields as touched to show errors
    if (countryCodeError || displayNameError) {
      // Trigger the change handlers to mark fields as touched
      if (countryCodeError) {
        handleCountryCodeChange({ target: { value: countryCode } });
      }
      if (displayNameError) {
        handleDisplayNameChange({ target: { value: displayName } });
      }

      return;
    }

    const success = await onSubmit();
    if (success) {
      onClose();
    }
  };

  return (

      <MUIModal
          open={open}
          onClose={onClose}
          title={localized.UpdateDomesticCountryTitle}
          onSubmit={handleSubmit}
          showDefaultButtons={false}
          maxWidth="sm"
          fullWidth
          customActions={
              <>
                  <ActionButton
                      variant="blue-solid"
                      onClick={onClose}
                      text={localized.Cancel}
                  />
                  <ActionButton
                      variant="blue-solid"
                      type="submit"
                      disabled={!isFormValid}
                      text={localized.Update}
                  />
              </>
          }
      >
          <div style={{ padding: "24px" }}>
              <div style={{ marginBottom: "16px" }}>
                  {localized.ValuesEligibleForUpdateBelow}
              </div>

              <DomesticCountryForm
                  countryCode={countryCode}
                  displayName={displayName}
                  countryCodeTouched={countryCodeTouched}
                  displayNameTouched={displayNameTouched}
                  handleCountryCodeChange={handleCountryCodeChange}
                  handleDisplayNameChange={handleDisplayNameChange}
                  handleCountryCodeBlur={handleCountryCodeBlur}
                  handleDisplayNameBlur={handleDisplayNameBlur}
                  validateCountryCode={validateCountryCode}
                  validateDisplayName={validateDisplayName}
                  localized={localized}
              />

              {dialogError && (
                  <Box
                      sx={{
                          marginTop: "16px",
                          padding: "12px",
                          backgroundColor: "#ffebee",
                          border: "1px solid #f44336",
                          borderRadius: "4px",
                      }}
                  >
                      <Typography variant="body2" color="error">
                          {dialogError}
                      </Typography>
                  </Box>
              )}
          </div>
      </MUIModal>
  );
};
